module.exports = __webpack_public_path__ + "img/152.0e9cba79.jpg";